import { useTranslation } from 'react-i18next'

import { useMe } from '@/api/hooks/useMe'

export const HomeHeader = () => {
  const { t } = useTranslation()
  const { data: me } = useMe()

  return (
    <div className="space-y-1 pt-20 text-center">
      <h2 className="text-4xl font-heading font-black">
        {t('homePage.greeting', { name: me?.firstName })}
      </h2>
    </div>
  )
}

export default HomeHeader
